import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { PaymentOptionalMethod, PaymentOptionalMethods } from '../../../../models/form/form';
import { getText } from '../../../../utilities/CultureUtilities';

interface Props {
  otherPayment: boolean;
  methods?: PaymentOptionalMethods | null;
  onChange: (otherPayment: boolean) => void;
}

const methodOrder: PaymentOptionalMethod[] = ['interac', 'cheque', 'cash', 'other'];

const PaymentMethodTiles: FC<Props> = ({ otherPayment, methods, onChange }: Props) => {
  const intl = useIntl();

  const getMethodLabel = (method: PaymentOptionalMethod) => {
    if (method === 'other') {
      const otherText = getText(methods?.otherText || '', intl.locale);
      if (otherText) {
        return otherText;
      }
    }

    return intl.formatMessage({ id: `formPublic.paymentMethod.${method}` });
  };

  let otherDescription = intl.formatMessage({ id: 'formPublic.optionalPayment' });
  const selectedMethods = methodOrder.filter((method) => (methods?.methods || []).includes(method));

  if (selectedMethods.length > 0) {
    otherDescription = selectedMethods.map(getMethodLabel).join(', ');
  }

  const tiles = [
    {
      id: 'card',
      isOther: false,
      icon: 'mdi-credit-card-outline',
      title: intl.formatMessage({ id: 'formPublic.paymentMethod.creditCard' }),
    },
    {
      id: 'other',
      isOther: true,
      icon: 'mdi-cash-multiple',
      title: otherDescription,
    },
  ];

  return (
    <div className="form-group">
      <div className="d-flex flex-column">
        <label className="input-label form-label">{intl.formatMessage({ id: 'formPublic.paymentMethod.title' })}</label>
        <div className="d-flex flex-wrap">
          {tiles.map((tile) => {
            const selected = tile.isOther === otherPayment;
            return (
              <button
                type="button"
                key={tile.id}
                data-testid={`payment-method-${tile.id}`}
                className={`tile ${selected ? 'selected' : ''}`}
                aria-pressed={selected}
                onClick={() => onChange(tile.isOther)}
              >
                <span className="tile-icon">
                  <span className={`mdi ${tile.icon}`} aria-hidden="true"></span>
                </span>
                <span className="tile-text">
                  <span className="tile-name">{tile.title}</span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodTiles;
